import { TERMS_MODULE_OPTINS } from "../../../../components/modules/compliance/config";
import { flowCaixabankKnownCustomer } from "../../flowCaixabankKnownCustomer";
import { flowCaixabankUnknownCustomerBREnabled } from "../../flowCaixabankUnknownCustomerBREnabled";
import { flowCaixabankUnknownCustomerBRDisabled } from "../../flowCaixabankUnknownCustomerBRDisabled";
import { flowDisabledLoan } from "../../flowDisabledLoan";
import { flowWelcomeAndTerms } from "../../flowWelcomeAndTerms";
import { DISABLED_LOAN_STATUS } from "../constants/DisabledLoanStatus";

export const caixabankFlows = [
  {
    ...flowDisabledLoan,
    // recalculateFlowOnEnd: true, ???
    condition: (processState, authState) => {
      return DISABLED_LOAN_STATUS.includes(processState?.loan?.status);
    },
  },
  {
    ...flowWelcomeAndTerms,
    condition: (processState, authState) => {
      return (
        !processState.participant.participantId ||
        !processState?.optIns ||
        processState?.optIns?.conditions_indicated
          .filter((condition) =>
            TERMS_MODULE_OPTINS.includes(condition.condition_type)
          )
          .some((condition) => condition.required && condition.checked !== true)
      );
    },
  },
  // {
  //   ...flowDocumentationIncidence,
  //   condition: (processState, authState) => {
  //     return processState?.documentationRequired?.required_files.some(
  //       (requiredFile) => requiredFile.status === documentStatus.INCIDENCE
  //     );
  //   },
  // },
  {
    ...flowCaixabankKnownCustomer,
    condition: (processState, authState) => {
      return processState?.caixabank?.isKnownCustomer === true;
    },
  },
  {
    ...flowCaixabankUnknownCustomerBRDisabled,
    condition: (processState, authState) => {
      return (
        !processState?.caixabank?.isKnownCustomer &&
        authState?.agent?.is_bank_reader_enabled === false
      );
    },
  },
  {
    ...flowCaixabankUnknownCustomerBREnabled,
    condition: (processState, authState) => {
      return (
        !processState?.caixabank?.isKnownCustomer &&
        authState?.agent?.is_bank_reader_enabled === true
      );
    },
  },
];
